var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-sans",attrs:{"id":"app"}},[_c('MarqueeSlider'),_c('TopNavbar'),_c('router-view'),(!_vm.$route.meta.hideFooter)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }